import http from '@/utils/http'

// 获取apple pay Token
export function postAppleToken(id, data) {
  return http.post(`/checkout/apple-pay/create-session/${id}`, data)
}

export function postAppleDecryptToken(id, data) {
  return http.post(`/checkout/apple-pay/decrypt-token/${id}`, data)
}
